import { render, staticRenderFns } from "./BlockFeaturedEntries.vue?vue&type=template&id=f69f81f6&"
import script from "./BlockFeaturedEntries.vue?vue&type=script&lang=js&"
export * from "./BlockFeaturedEntries.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeaturedEntries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports